import { gql } from 'graphql-request';

export const MULTIPLE_REPRESENTATIVES_PROFILE = gql`
  query ($search: String) {
    profiles(search: $search) {
      use_own_talent_permissions
      talent_permissions
      id
      representation_type
      primary
      talent {
        stage_name
      }
      agency {
        full_name
        country
        contact_number
        primary_address {
          country_code
        }
        talent_permissions
      }
      casting_private
      division {
        id
        name
      }
      primary_medium_attachment {
        modified_attachment
      }
      completeness
      casting_company {
        name
        full_name
        contact_number
      }
    }
  }
`;

export const SINGLE_REPRESENTATIVE_PROFILE = gql`
  query ($id: ID!) {
    profile(id: $id) {
      archived
      id
      representation_type
      primary
      talent {
        stage_name
      }
      agency {
        talent_permissions
        full_name
        country
        contact_number
        primary_address {
          country_code
        }
      }
      casting_private
      division {
        id
        name
      }
      primary_medium_attachment {
        modified_attachment
      }
      completeness
      casting_company {
        name
        full_name
        contact_number
      }
      talent_permissions
      use_own_talent_permissions
    }
  }
`;

export const AGENCIES_PAGINATION = gql`
  query ($first: Int, $after: String, $search: String, $country: String, $state: String) {
    agencies_connection(first: $first, after: $after, search: $search, country: $country, state: $state) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        type
        id
        full_name
        name
        country
        divisions {
          id
          name
        }
        required_access_code
        logo
        addresses {
          id
          type
          address1
          zip_code
          state_code
          country_code
          primary
          city_suburb
        }
      }
    }
  }
`;

export const SINGLE_REPRESENTATIVE_ATTACHED_MEDIA = gql`
  query ($mediumable_id: ID!, $mediumable_type: String!, $file_type: String) {
    medium_attachments_connection(
      mediumableId: $mediumable_id
      mediumableType: $mediumable_type
      fileType: $file_type
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        primary
        mediumable_id
        mediumable_type
        medium {
          cropped_attachment_url
          attachment_url
          modified_attachment_url
          modified_metadata
          id
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
          tag_list
        }
        sort
      }
    }
  }
`;

export const SINGLE_REPRESENTATIVE_HIDDEN_MEDIA = gql`
  query ($user_id: ID, $file_type: String, $media_bin: Boolean, $profile_id: ID) {
    media_connection(userId: $user_id, fileType: $file_type, mediaBin: $media_bin, profileId: $profile_id) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        file_name
        file_type
        attachment_url
        modified_attachment_url
        cropped_attachment_url
        modified_metadata
      }
    }
  }
`;

export const SINGLE_REPRESENTATIVE_RESUMES = gql`
  query ($id: ID!) {
    profile(id: $id) {
      talent {
        resume
      }
      resume_category_ids
    }
  }
`;
